import { parsePhoneNumber } from 'react-phone-number-input';

const blank = '';

/*
    Our phone component will store value as json object with a code and a number property.
    Use that to get the formatted value otherwise return the object as a string
    But phone can also be imported as raw strings.
    Account for anything and try to make a phone number all pretty.
*/
export const formatPhoneNumber = (value, country, formatNational = true) => {
    if (!value) {
        return blank;
    }

    let p;

    if (typeof (value) === 'object') {
        //It is assumed there is no valid country code or number of '0' since that would be falsey
        if (value.code && value.number) {
            try {
                p = parsePhoneNumber(`+${value.code} ${value.number}`);
                if (p) {
                    return formatNational ? (p.countryCallingCode == '1' ? `+${p.countryCallingCode} ${p.formatNational()}` : `${p.formatInternational()}`) : p.number;
                }
                return `+${value.code}${value.number}`;
            }
            catch {
                return `+${value.code}${value.number}`;
            }
        }
        else if (value.number) {
            return value.number;
        }
        else {
            return JSON.stringify(value);
        }
    }
    else if (typeof (value) === 'string') {
        try {
            p = parsePhoneNumber(value, country);
            if (p) {
                return formatNational ? (p.countryCallingCode == '1' ? `+${p.countryCallingCode} ${p.formatNational()}` : `${p.formatInternational()}`) : p.number;
            }
        }
        catch {
            return value.toString();
        }
    }

    return value.toString();
};
